import React, { useState, useEffect } from "react";
import DataTable from "../base-components/DataTableBase";
import EditVolumeConteneur from "./EditVolumeConteneur";
import Toast from "react-bootstrap/Toast";
import ToastContainer from "react-bootstrap/ToastContainer";
import useApi from "../../hooks/useApi";

export default function VolumesConteneurs() {
  const { apiGetVolumesConteneurs } = useApi();

  const [dataState, setDataState] = useState();
  const [getIsDataLoading, setIsDataLoading] = useState(true);

  const [showToastState, setShowToastState] = useState(false);
  const [toastMsgState, setToastMsgState] = useState();

  useEffect(() => {
    handleRefreshData();
  }, []);

  async function handleRefreshData() {
    apiGetVolumesConteneurs(true)
      .then((res) => {
        setDataState(res);
        setIsDataLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  // const handleSaveItem = async (item, isEdit) => {
  //   try {
  //     if (isEdit) {
  //       await axios.put("EditVolumeConteneur", item);
  //       const itemInArray = dataState.find((a) => a.UID === item.UID);
  //       dataState[dataState.indexOf(itemInArray)] = item;
  //       setDataState([...dataState]);
  //     } else {
  //       const response = await axios.post("AddVolumeConteneur", item);
  //       setDataState(dataState.concat(response.data));
  //     }

  //     return true;
  //   } catch (err) {
  //     console.error(err);
  //     setToastMsgState(err.response.data);
  //     setShowToastState(true);
  //     return false;
  //   }
  // };

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.Nom,
      sortable: true,
    },
    // {
    //   name: "Donnée système",
    //   selector: (row) => (Number(row.IsSystem) === 1 ? "Oui" : "Non"),
    //   sortable: true,
    // },
    {
      name: "Actif",
      selector: (row) => (Number(row.Actif) === 1 ? "Actif" : "Non-actif"),
    },
    {
      button: true,
      cell: (record) => (
        <EditVolumeConteneur
          isEdit={true}
          item={Object.assign({}, record)}
          handleRefreshData={handleRefreshData}
        />
      ),
    },
  ];

  return (
    <div>
      <h1 align="center">Volumes des conteneurs</h1>

      <div align="right">
        <EditVolumeConteneur
          isEdit={false}
          item={{}}
          handleRefreshData={handleRefreshData}
          onClose={handleRefreshData}
        />
      </div>

      <br />

      <div>
        <DataTable
          title=""
          columns={columns}
          data={dataState}
          progressPending={getIsDataLoading}
        />
      </div>

      <ToastContainer
        className="p-3"
        position="middle-end"
        style={{ zIndex: 1 }}
      >
        <Toast
          bg="danger"
          onClose={() => setShowToastState(false)}
          show={showToastState}
          delay={4000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Erreur</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toastMsgState}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
